export const OrgAdminServerConfigTestIds = {
  deleteperiodInput: 'deleteperiod_input',
  deleteperiodSlider: 'deleteperiod_slider',
  cancelDeleteperiod: 'cancel_deleteperiod',
  saveDeleteperiod: 'save_deleteperiod'
} as const;
